import detail from "../../api/detail";
import list from "../../api/list";
import router from "@/router";
import store from "..";
import i18n from '../../i18n.js' 
import Vue from "vue";

const state = () => ({
  isSearching: false,
  addedToBasket: false,
  currentCategory: null,
  origin: "",
  categories: [],
  stateSelectedGold: "",
  selectedSku: "",
  // quantity: 1,
  retailPerc: 1,
  vat: 1,
  selectedProduct: {
    //object selected used in detail by the configuration selected
    images: null,
    placeholders: {},
    price: null,
    sku: "",
    quantity: 1,
    skuBase: "",
    jewelType: "",
    logo: false,
    writing: undefined,
    warranty: false,
    rhodiumType: "RHODIUM_NORMAL",
    singleAmount: 0,
    amount: 0,
    note: null,
  },
  optionsMap: {
    gold: "0",
    stoneColor: "stone",
    stoneSize: "size",
    size: "1",
    backing: "2",
    chain: "4",
    letter: "13",
  },
  optionsMapDefault: {
    chain: ["cv9-4-1", "cv9-4-3", "cv9-4-2"],
    gold1: ["1"],
    gold2: ["1"],
    gold3: ["1"],
    gold4: ["1"],
    size1: ["13"],
    size2: ["17", "17.5"],
    pairHole7: ["4"]
  },
  imagesAvailable: [],
  additionalValues: 0, //value additional based on logo and writing price
  additionalSkuLabelArray: [],
  preselectedJewel: {},
  selectedStoneObj: {},
  selectedStoneSizeObj: {},
  jewelDescription: "",
  jewelBillingDescription: "",
  frame: false, //logo engraving boolean
  writing: undefined, //customize engraving label
  warranty: false,
  logo: false,
  preselectedLogo: false,
  preselectedWarranty: false,
  exhibitor: undefined, //customize engraving label
  rhodiumType: "RHODIUM_NORMAL",
  basePrice: 0,
  avgPrice: 0,
  currentJewelSelection: {
    //current jewel selected from the list and received from the BE
    name: "",
    description: "",
    images: null,
    keys: {},
    options: [
      {
        type: "",
        values: [
          {
            id: "",
            label: "",
            image: null,
          },
        ],
      },
    ],
  },
  stoneColorObj: {},
  stoneSizeObj: {},
});

// getters
const getters = {};

// actions
const actions = {
  getValues({ commit }, sku) {
    commit("setSearching", true);
    detail.getValues((jewels) => {
      commit("setJewelOptions", jewels.data);
      setTimeout(() => {
        commit("setCurrentCategory");
      }, 200);
    }, sku);
  },
  getValuesForKit({ commit }, sku) {
    commit("setSearching", true);
    detail.getValuesForKit((jewels) => {
      jewels.data.sku = sku;
      commit("setJewelOptions", jewels.data);
      setTimeout(() => {
        commit("setCurrentCategory");
      }, 200);
    }, sku);
  },
  getListCategories({ commit }, search) {
    list.getList((searchJewel) => {
      commit("setCurrentCategory", searchJewel);
    }, search);
  },
};

// mutations
const mutations = {
  setOrigin(state, value) {
    state.origin = value;
  },
  setCurrentCategory(state, values) {
    let val;
    if (values) {
      state.categories = values;
      val = values.find((a) => a.id === state.currentJewelSelection.categoryId);
    } else {
      val = state.categories.find(
        (a) => a.id === state.currentJewelSelection.categoryId
      );
    }
    state.currentCategory = Object.assign({}, val, null);
  },
  resetAdditionalSkuLabelArray(state) {
    state.additionalSkuLabelArray = [];
  },
  resetDetail(state) {
    state.isSearching = false;
    state.addedToBasket = false;
    state.retailPerc = 1;
    state.vat = 1;
    state.selectedSku = "";
    state.selectedProduct = {
      //object selected used in detail
      images: null,
      placeholders: {},
      price: null,
      sku: "",
      quantity: 1,
      skuBase: "",
      jewelType: "",
      logo: false,
      writing: undefined,
      warranty: false,
      rhodiumType: "RHODIUM_NORMAL",
      singleAmount: 0,
      amount: 0,
      note: null,
    };
    state.optionsMap = {
      gold: "0",
      stoneColor: "stone",
      stoneSize: "size",
      size: "1",
      backing: "2",
      chain: "4",
      letter: "13",
    };
    state.optionsMapDefault = {
      chain: ["cv9-4-1", "cv9-4-3", "cv9-4-2"],
      gold1: ["1"],
      gold2: ["1"],
      gold3: ["1"],
      gold4: ["1"],
      size1: ["13"],
      size2: ["17", "17.5"],
      pairHole7: ["4"]
    };
    state.imagesAvailable = [];
    state.additionalValues = 0; //value additional based on logo and writing price
    state.additionalSkuLabelArray = [];
    state.preselectedJewel = {};
    state.selectedStoneObj = {};
    state.selectedStoneSizeObj = {};
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
    state.logo = false; //logo engraving boolean
    state.writing = undefined; //customize engraving label
    state.warranty = false;
    state.preselectedLogo = false;
    state.preselectedWarranty = false;
    state.rhodiumType = "RHODIUM_NORMAL";
    state.basePrice = 0;
    state.avgPrice = 0;
    state.currentJewelSelection = {
      //current jewel select by sku base
      name: "",
      description: "",
      images: null,
      keys: {},
      options: [
        {
          type: "",
          values: [
            {
              id: "",
              label: "",
              image: null,
            },
          ],
        },
      ],
    };
    state.stoneColorObj = {};
    state.stoneSizeObj = {};
  },
  setSearching(state, value) {
    //searching boolean value that shows the loader if there's a check
    state.isSearching = value;
  },
  setFrame(state, value) {
    //this function sets logo, writing and rhodiumType based on the value and change the sku by the rhodium type
    state[value.label] = value.value;
    state.addedToBasket = false;
    if (value.label === "frame") {
      Vue.set(state.additionalSkuLabelArray, 1, null);
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 1, "-f");
      }
    }
  },
  setLogo(state, value) {
    //this function sets logo, writing and rhodiumType based on the value and change the sku by the rhodium type
    state[value.label] = value.value;
    state.addedToBasket = false;
    if (value.label === "logo") {
      Vue.set(state.additionalSkuLabelArray, 1, null);
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 1, "-l");
      }
    }
  },
  setWarranty(state, value) {
    //this function sets logo, writing and rhodiumType based on the value and change the sku by the rhodium type
    state[value.label] = value.value;
    state.addedToBasket = false;
    if (value.label === "warranty") {
      Vue.set(state.additionalSkuLabelArray, 2, null);
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 2, "-wa");
      }
    }
  },
  setExhibitor(state, value) {
    //this function sets logo, writing and rhodiumType based on the value and change the sku by the rhodium type
    state[value.label] = value.value;
    state.addedToBasket = false;
    if (value.label === "exhibitor") {
      Vue.set(state.additionalSkuLabelArray, 0, null);
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 0, "-ex");
      }
    }
  },

  // this function set the quantity of jewel in the detail
  setQuantityProduct(state, value) {
    state.quantity = parseInt(value);
  },

  // this functions set the retail percentage that arrives from Magento
  setRetailProductPerc(state, value) {
    state.retailPerc = parseFloat(value);
  },
  setVatProduct(state, value) {
    state.vat = parseFloat(value);
  },

  setJewelOptions(state, jewel) {
    state.currentJewelSelection = jewel;
    let ddEngr = String(
      new Date(state.currentJewelSelection.engravingDate).getDate()
    ).padStart(2, "0");
    let mmEngr = String(
      new Date(state.currentJewelSelection.engravingDate).getMonth() + 1
    ).padStart(2, "0"); //January is 0!
    let yyyyEngr = new Date(
      state.currentJewelSelection.engravingDate
    ).getFullYear();
    state.currentJewelSelection.engravingDate =
      ddEngr + "/" + mmEngr + "/" + yyyyEngr;

    let ddShip = String(
      new Date(state.currentJewelSelection.shipmentDate).getDate()
    ).padStart(2, "0");
    let mmShip = String(
      new Date(state.currentJewelSelection.shipmentDate).getMonth() + 1
    ).padStart(2, "0"); //January is 0!
    let yyyyShip = new Date(
      state.currentJewelSelection.shipmentDate
    ).getFullYear();
    state.currentJewelSelection.shipmentDate =
      ddShip + "/" + mmShip + "/" + yyyyShip;

    if (
      state.currentJewelSelection.itemsInKit &&
      state.currentJewelSelection.itemsInKit.length > 0
    ) {
      state.currentJewelSelection.itemsInKit.sort((a, b) =>
        a.sku > b.sku ? 1 : b.sku > a.sku ? -1 : 0
      );
    }

    state.imagesAvailable = [];
    state.additionalValues = 0;
    state.basePrice = 0;
    state.avgPrice = 0;

    for (const key in state.currentJewelSelection.keys) {
      if (state.currentJewelSelection.keys.hasOwnProperty(key)) {
        if (state.currentJewelSelection.keys[key].images) {
          state.imagesAvailable = state.currentJewelSelection.keys[key].images;
        } else {
          state.imagesAvailable.push("");
        }
      }
    }
    state.imagesAvailable = [...new Set(state.imagesAvailable)];

    state.selectedStoneSizeObj = {};
    state.selectedStoneObj = {};
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
    state.preselectedLogo = state.currentJewelSelection.preselectedJewelOptions?.includes("LOGO");
    state.preselectedWarranty = state.currentJewelSelection.preselectedJewelOptions?.includes("WARRANTY");

    jewel.options.forEach((el) => {
      if (el.type === "stoneColor") {
        state.stoneColorObj[`stoneColor${el.stoneNumber}`] = {
          values: el.values,
          type: el.stoneNumber,
        };
      }
    });
    state.stoneSizeObj = {};
    state.jewelDescription = "";
    state.jewelBillingDescription = "";

    if (jewel.options) {
      jewel.options.forEach((el) => {
        //mappa per ciclare su tutte le possibili stone size e mostrarle
        if (el.type === "stoneSize") {
          state.stoneSizeObj[`stoneSize${el.stoneNumber}`] = {
            values: el.values,
            type: el.stoneNumber,
            stoneType: el.stoneType,
            sizeUnit: el.sizeUnit,
          };
        }
      });

      jewel.options.forEach((el) => {
        if (
          el.values.length > 0 &&
          el.type !== "stoneSize" &&
          el.type !== "stoneColor"
        ) {
          el.values.sort(function(a, b) {
            return a.id - b.id || a.label.localeCompare(b.label);
          });
        }
      });
    }

    state.isSearching = false;
  },
  setStateGold(state, value) {
    state.stateSelectedGold = value;
  },
  setAddedToBasket(state, value) {
    state.addedToBasket = value;
  },
  setSelectedStoneObj(state, obj) {
    if (state.selectedStoneObj[obj.type]) {
      delete state.selectedStoneObj[obj.type];
    }
    Vue.set(state.selectedStoneObj, obj.type, null);
    Vue.set(state.selectedStoneObj, obj.type, obj.value);
  },
  resetSelectedStoneObj(state) {
    state.selectedStoneObj = {};
    state.stoneColorObj = {};
  },
  resetCurrentJewel(state) {
    state.currentJewelSelection = {
      name: "",
      description: "",
      images: null,
      keys: {},
      options: [
        {
          type: "",
          values: [
            {
              id: "",
              label: "",
              image: null,
            },
          ],
        },
      ],
    };
    state.selectedProduct = {};
    state.selectedSku = "";
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
  },
  setSelectedStoneSizeObj(state, obj) {
    if (state.selectedStoneSizeObj[obj.type]) {
      delete state.selectedStoneSizeObj[obj.type];
    }
    Vue.set(state.selectedStoneSizeObj, obj.type, null);
    Vue.set(state.selectedStoneSizeObj, obj.type, obj.value);
  },
  resetSelectedStoneSizeObj(state) {
    state.selectedStoneSizeObj = {};
    state.stoneSizeObj = {};
  },
  resetCurrentCategory(state, values) {
    state.currentCategory = null;
  },
  changePrice(state, price) {
    state.additionalValues = state.additionalValues + price;
  },
  setPreselectedProduct(state, jewelSelection) {
    // if (jewelSelection
    //   && Object.keys(jewelSelection).length === 0 && jewelSelection.constructor === Object)
    //   state.additionalSkuLabelArray = []
    state.preselectedJewel = jewelSelection;
  },
  addValuesToSelected(state, obj) {
    if (state.selectedProduct) {
      state.selectedProduct.description = state.jewelDescription;
      state.selectedProduct.billingDescription = state.jewelBillingDescription;
      state.selectedProduct.deliveryDate = state.frame
        ? state.currentJewelSelection.engravingDate
        : state.currentJewelSelection.shipmentDate;
      state.selectedProduct.name = state.currentJewelSelection.name;
      state.selectedProduct.productType =
        state.currentJewelSelection.productType;
      state.selectedProduct.quantity = parseInt(obj.qnt);
      state.selectedProduct.note = obj.note;
      state.selectedProduct.frame = state.frame;
      state.selectedProduct.logo =
        state.currentJewelSelection.productType === "EXHIBITORS"
          ? true
          : state.logo;
      state.selectedProduct.sku =
        state.currentJewelSelection.productType === "KIT"
          ? state.currentJewelSelection.sku +
            state.additionalSkuLabelArray.join("")
          : state.selectedProduct.sku + state.additionalSkuLabelArray.join("");
      state.selectedProduct.skuBase = router.currentRoute.params.sku;
      state.selectedProduct.rhodiumType = state.rhodiumType;

      let price = (state.basePrice + state.additionalValues) * obj.qnt;
      state.selectedProduct.price = parseFloat(price.toFixed(2));
      let singleAmount = state.basePrice + state.additionalValues;
      state.selectedProduct.singleAmount = parseFloat(singleAmount.toFixed(2));
      let amount = (state.basePrice + state.additionalValues) * obj.qnt;
      state.selectedProduct.amount = parseFloat(amount.toFixed(2));
    }
  },
  addValueToJewel(state, obj) {
    if (state.selectedProduct) {
      state.selectedProduct[obj.category] = obj.value;
    }
  },
  setValueAndChangeRing(state, obj) {
    state.addedToBasket = false;
    state.selectedProduct = state.currentJewelSelection.keys[obj.sku];
    state.selectedSku =
      state.currentJewelSelection.productType === "KIT"
        ? state.currentJewelSelection.sku
        : state.currentJewelSelection.keys[obj.sku]
        ? state.currentJewelSelection.keys[obj.sku].sku
        : "";
    if (state.selectedProduct) {
      state.basePrice = state.selectedProduct.optionPrice[0].price;
      state.avgPrice = state.selectedProduct.optionPrice[0].averagePrice;
    } else {
      state.basePrice = 0;
      state.avgPrice = 0;
    }

    /**
     *
     * REPLACING PLACEHOLDERS IN DESCRIPTION
     *
     */
    var reg = /{(.*?)}/g;
    var found;
    var foundBilling;
    if (state.selectedProduct) {
      state.jewelDescription = state.currentJewelSelection.description;
      state.jewelBillingDescription =
        state.currentJewelSelection.billingDescription;
      while ((found = reg.exec(state.currentJewelSelection.description))) {
        if (state.selectedProduct.placeholders[found[1]]) {
          state.jewelDescription = state.jewelDescription.replace(
            `${found[0]}`,
            state.selectedProduct.placeholders[found[1]]
          );
        } else {
          state.jewelDescription = state.jewelDescription.replace(
            found[0],
            "--"
          );
        }
      }
      if (state.currentJewelSelection.billingDescription) {
        while (
          (foundBilling = reg.exec(
            state.currentJewelSelection.billingDescription
          ))
        ) {
          if (state.selectedProduct.placeholders[foundBilling[1]]) {
            state.jewelBillingDescription = state.jewelBillingDescription.replace(
              `${foundBilling[0]}`,
              state.selectedProduct.placeholders[foundBilling[1]]
            );
          } else {
            state.jewelBillingDescription = state.jewelBillingDescription.replace(
              foundBilling[0],
              "--"
            );
          }
        }
      }
    } else {
      state.jewelDescription = "";
      state.jewelBillingDescription = "";
    }

    /**
     *
     * GET ALL THE AVAILABLE CONFIGURATION IN THE JEWEL
     *
     */

    // create an object <key,value> where the keys are the configuration keys
    const keysList = Object.assign({}, state.currentJewelSelection.keys);

    // create a field k as an array within the configuration parameters in each element of keysList
    Object.keys(keysList).map((key, index) => {
      const k = key.split("|");
      const o = keysList[key];
      o.k = k;
    });

    for (
      let index = 0;
      index < state.currentJewelSelection.options.length;
      index++
    ) {
      var temp = state.currentJewelSelection.options[index].values;
      state.currentJewelSelection.options[index].values = undefined;
      temp.forEach((el) => {
        el.disabled = false;
      });
      state.currentJewelSelection.options[index].values = temp;
    }

    const valuesInSku =
      obj.sku.indexOf("|") > -1 ? obj.sku.split("|") : [obj.sku];

    // list is an array of all values of the keyList map
    var listValues = Object.values(keysList);
    for (let i = 0; i < valuesInSku.length; i++) {
      if (valuesInSku[i] !== "null") {
        var list1 = listValues.filter((e) => e.k[i] === valuesInSku[i]);

        for (
          let index = 0;
          index < state.currentJewelSelection.options.length;
          index++
        ) {
          if (index !== i) {
            const listMap = list1.map((e) => e.k[index]);
            const distinct = (value, index, self) => {
              return self.indexOf(value) === index;
            };
            var list2 = listMap.filter(distinct);
            const t = state.currentJewelSelection.options[index].values;
            state.currentJewelSelection.options[index].values = undefined;
            t.forEach((element) => {
              let valueToCheck = element.id.replace(
                "{gt}",
                state.stateSelectedGold
              );
              if (list2.includes(valueToCheck)) {
                // do nothing
              } else {
                element.disabled = true;
              }
            });
            state.currentJewelSelection.options[index].values = t;
          }
        }
      }
    }
    let toAllElements = listValues;
    state.imagesAvailable = [];
    for (let i = 0; i < valuesInSku.length; i++) {
      if (valuesInSku[i] !== "null") {
        toAllElements = toAllElements.filter((e) => e.k[i] === valuesInSku[i]);
      }
    }
    toAllElements.forEach((element) => {
      state.imagesAvailable.push(element.images ? element.images[0] : "");
    });
    state.imagesAvailable = [...new Set(state.imagesAvailable)];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
